import styled from 'styled-components';

import { Link } from '../Link/Link';

export const Root = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
`;

export const ImageContainer = styled.div`
  margin-bottom: 8px;
  aspect-ratio: 4/5;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const BrandLink = styled(Link)`
  color: #e1000f;
  font-size: 14px;
  font-weight: 700;
  line-height: 25px;
  text-transform: uppercase;
`;

export const Name = styled.div`
  margin: 4px 0 6px;
  font-size: 20px;
  font-weight: 700;
  line-height: 25px;
`;

export const Role = styled.div`
  font-size: 17px;
  line-height: 25px;
  letter-spacing: 0.17px;
  text-decoration: none;
`;

export const SocialLink = styled.a`
  font-size: 17px;
  line-height: 25px;
  letter-spacing: 0.17px;
  text-decoration: none;
`;

export const Bio = styled.p`
  margin-top: 12px;
  font-size: 15px;
  line-height: 22px;
  text-align: left;
  color: #333;
`;
